import { createContext } from 'react';

const ProductCardContext = createContext(null);

export default ProductCardContext;
